import { useEffect } from 'react'

export const DEFAULT_PAGE_TITLE = 'Club 4X4 Customer Portal'

/**
 * Sets document.title for the current route. Restores the default on unmount.
 */
export function usePageTitle(title: string | undefined) {
  useEffect(() => {
    const next = title?.trim()
    document.title = next ? `${next} | Club 4X4` : DEFAULT_PAGE_TITLE
    return () => {
      document.title = DEFAULT_PAGE_TITLE
    }
  }, [title])
}
